/**
 * Mainly used for the InputNew component to also accepts zero (0) value e.g. 08-08-1988
 *
 * @param value
 * @returns {boolean}
 */
export const isEmptyInputValue = value => value === undefined || value == null || value.length <= 0;
